<template>
    <SelectButton
        v-model="timeOption"
        :options="filterTimeOptions"
        :disabled="disabled"
        :allow-empty="false"
        option-label="label"
        :pt="ptSelectButton"
        @change="(event) => emit('filterChanged', event.value)"
    />
</template>

<script setup lang="ts">
import { type ModelRef } from 'vue'
import SelectButton from 'primevue/selectbutton'
import { filterTimeOptions, type TimeOptionLabel } from '@/utils/time'

interface Props {
    disabled: boolean
}
const props = withDefaults(defineProps<Props>(), {
    disabled: false,
})

const emit = defineEmits(['filterChanged'])

const timeOption: ModelRef<TimeOptionLabel> = defineModel({
    default: filterTimeOptions[2],
})
const ptSelectButton = {
    root: { class: 'filter-select-button' },
}
</script>

<style lang="less" scoped>
@import '@/styles/prime-vue/colours.less';
@import '@/styles/prime-vue/variables.less';
@import '~@/styles/rain/variables.less';

.filter-select-button {
    box-shadow: @shadow-xs;

    :deep(.p-togglebutton) {
        padding: @gutterSpacing-base @gutterSpacing-md;
        box-sizing: border-box;
    }
    :deep(.p-togglebutton-label) {
        color: @text-secondary;
        font-size: @fontSize-base;
        line-height: @lineHeight-base;
    }
}
</style>
